import { useContext, useState } from 'react';
import { sendPostData } from '../../../fetchApi/sendPostData';
import Button from '../../common/button/Button';
import FormField from '../../common/FormField/FormField';
import { PopUpContext } from '../../common/popUp/PopUp';
import LargeIcon from '../../svg/logo/LargeIcon';
import { FormDataContext } from '../FormContext';
import ResetPassword from '../resetPassword/ResetPassword';
import SignUp from '../signup/signUp';
import './Login.scss';
import axios from 'axios';
import AuthContext from '../../../store/auth-context';
const loginAPIUrl = '/auth/login';

// import MediumIcon from "../../svg/logo/MediumIcon"

const Login = (Props) => {
  const ctx = useContext(AuthContext);
  const loginData = useContext(FormDataContext).login;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const popUp = useContext(PopUpContext);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('http://localhost:8080/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: loginData.email.value.val,
        password: loginData.password.value.val,
      }),
    })
      .then((res) => {
        if (res.status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (res.status !== 200 && res.status !== 201) {
          setError(true);
          console.log('Error!');
          throw new Error('Logging a user failed!');
        }

        return res.json();
      })
      .then((resData) => {
        setIsLoggedIn(true);
        setLoading(true);
        console.log('resData:', resData);
        localStorage.setItem('token', resData.token);
        localStorage.setItem('userId', resData.userId);
        const remainingMilliseconds = 60 * 60 * 1000;
        const expiryDate = new Date(
          new Date().getTime() + remainingMilliseconds
        );
        localStorage.setItem('expiryDate', expiryDate.toISOString());

        ctx.login(
          localStorage.getItem('token'),
          localStorage.getItem('expiryDate')
        );

        // window.location.replace('/home');
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form
        className={
          Props.direction == 'previous'
            ? 'previous loginContainer'
            : 'loginContainer'
        }
        onSubmit={handleSubmit}
      >
        <div className="logo">
          <LargeIcon />
        </div>
        <FormField
          type="text"
          onBlur={(text) => {
            loginData.email.checkError(text);
          }}
          message={loginData.email.value.err}
          name="email"
          value={loginData.email.value.val}
          changeTo={(text) => {
            loginData.email.changeTo(text);
          }}
          placeholder="Email Adress"
        />
        <FormField
          type="password"
          onBlur={() => {}}
          value={loginData.password.value.val}
          changeTo={(text) => {
            loginData.password.changeTo(text);
          }}
          placeholder="Password"
        />

        <div className="forgetPassword">
          <a
            href="/reset-password"
            onClick={() => {
              popUp.showPopUp('small', <ResetPassword />);
            }}
          >
            Forgot Password?
          </a>
        </div>
        {error && <p className="notlogin"> Enter Correct Information</p>}
        {/* <button
        type="submit"
        className="loginButton"
        disabled={loading}
        onClick={(e) => {
          handleSubmit(e);
          if (!error) {
            popUp.closePopUp();
          }
        }}
      >
        {loading ? 'Loading...' : 'Login'}
      </button> */}
        <button
          className="formBtn"
          disabled={loading}
          type="submit"
          // onClick={() => {
          //   if (!error) {
          //     popUp.closePopUp();
          //   }
          // }}
        >
          {loading ? <div className="dots"></div> : 'Log in'}
        </button>
        {/* <Button
        disabled={loading}
        onClick={(e) => {
          if (
            loginData.email.value == '' ||
            loginData.password.value == '' ||
            error
          ) {
            toggleLoading(true);
            setError(true);
            toggleLoading(false);
          } else {
            alert('login done');
            // window.location.replace('/home');
            popUp.closePopUp();
          }
        }}
      >
        Log In
      </Button> */}

        <div className="signUpOption">
          <p>
            New to MyNextMUN?{' '}
            <a
              onClick={() => {
                popUp.showPopUp('small', <SignUp />);
              }}
            >
              Sign Up
            </a>
          </p>
        </div>
      </form>
      {/* <button type="submit" onClick={logoutHandler}>
        logout
      </button> */}
    </>
  );
};
export default Login;
